import React from 'react';
import useENotification from '../../../../../../hooks/eNotification';

const path = '../../oldPages/e-notification/archive-template/filled-template/index.html';

function ENotificationFilledArchiveTemplate() {
  const { iframeRef } = useENotification();

  return (
    <iframe ref={iframeRef} title="e-notification-filled-archive-template" src={path} width="100%" height="1300px" />
  );
}

export default ENotificationFilledArchiveTemplate;
